import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Header } from "@/components/site/Header";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

const STATUE = "https://static.prod-images.emergentagent.com/jobs/55e8a073-484f-45a0-9ce0-724193ee87a9/images/f3a1cf0ddc46deb2c12db4959544af4be179fab967318b2e99a19945022ed054.jpeg";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const [role, setRole] = useState(sp.get("role") === "manufacturer" ? "manufacturer" : "admin");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const u = await login(email, password, role);
      nav(u.role === "admin" ? "/admin" : "/manufacturer");
    } catch (ex) {
      setErr(errMsg(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen relative grid place-items-center px-6" data-testid="login-page">
      <Header />
      <img src={STATUE} alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_10%,#0B0907_75%)]" />
      <form onSubmit={submit} className="relative w-full max-w-md rounded-sm border border-[#D4AF37]/25 bg-[#14110E]/80 backdrop-blur-xl p-8 fade-up" data-testid="login-form">
        <p className="text-[11px] uppercase tracking-[0.5em] text-[#D4AF37] text-center">Portal</p>
        <h1 className="font-display text-3xl text-center mt-3">Enter the sanctum</h1>
        <div className="grid grid-cols-2 gap-2 mt-8 rounded-full border border-[#D4AF37]/20 p-1">
          {["admin", "manufacturer"].map((r) => (
            <button type="button" key={r} onClick={() => setRole(r)} className={`rounded-full py-2 text-xs uppercase tracking-[0.2em] transition-colors ${role === r ? "bg-[#D4AF37] text-[#0B0907]" : "text-[#A89F91]"}`} data-testid={`login-role-${r}`}>
              {r === "admin" ? "Admin" : "Manufacturer"}
            </button>
          ))}
        </div>
        <div className="space-y-4 mt-6">
          <Input required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-[#0B0907] border-[#D4AF37]/20 h-11" data-testid="login-email" />
          <Input required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-[#0B0907] border-[#D4AF37]/20 h-11" data-testid="login-password" />
        </div>
        {err && <p className="text-sm text-[#E06D3B] mt-4" data-testid="login-error">{err}</p>}
        <button disabled={busy} className="btn-glow w-full mt-6 rounded-full bg-[#D4AF37] py-3.5 font-semibold uppercase tracking-[0.2em] text-sm text-[#0B0907] hover:bg-[#F3E5AB] disabled:opacity-50" data-testid="login-submit-button">
          {busy ? "Signing in…" : "Sign in"}
        </button>
        <p className="text-xs text-[#6E6558] text-center mt-5">Manufacturer accounts are created by the admin.</p>
      </form>
    </div>
  );
}
